<template>
  <div v-if="sf_demo_loan_info!=null && ifUserCanAccess">
    <demo-loan-page v-if="sf_demo_loan_info != null && sf_account_info!=null && ifUserCanAccess"
                  :prop_demo_loan_page_obj="sf_demo_loan_info"
                  :prop_account_page_obj="sf_account_info"
                  :prop_opportunity_page_obj="sf_opty_info"
                  :prop_user_sites="userSites"
                  :prop_user="login_user_name"
                  :prop_user_roles="userRoles" />
  </div>

</template>
<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'demoloan-master-gage',
    props: {
      prop_demo_loan_page_obj: {
        default: null
      },
      prop_account_page_obj: {
        default: null
      },
      prop_opportunity_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
    },
    data() {
      return {
        function_name: 'Demo Loan Master Page',
        access_to_opty: false,
        sf_account_info: null,
        sf_demo_loan_info: null,
        sf_opty_info: null,
        demo_loan_id: encodeURIComponent(this.$route.params.demo_loan_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        accountFields: [
          { key: 'OPPORTUNITY_NUMBER__C', label: 'Opportunity Number', thClass: 'align-middle', sortable: true },
          { key: 'OPPORTUNITY_NAME', label: 'Opportunity Name', thClass: 'align-middle', sortable: true },
          { key: 'STAGE', label: 'Stage', thClass: 'align-middle', sortable: true },
          { key: 'CREATEDDATE', label: 'Created Date', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'LASTMODIFIEDDATE', label: 'Lastmodified Date', thClass: 'align-middle', sortable: true }
        ],
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        task_page_obj: null,
      };
    },
    created() {
      let self = this;
      self.date_from = moment().format('YYYY-MMM-DD');
      self.userSites = self.prop_user_sites;
      self.login_user_name = self.prop_user;
      self.userRoles = self.prop_user_roles;
      self.checkLoggedIn();
      self.access_to_opty = self.sfdcSearchEnabled();

      if (self.sfdcSearchEnabled) {
        if (self.prop_demo_loan_page_obj == null) {
          self.getDemoLoanInfo();
        } else {
          self.sf_demo_loan_info = self.prop_demo_loan_page_obj;
          self.demo_loan_id = self.sf_demo_loan_info.ID;
        }
      } else {
        this.$message.error(`You do not have permissions to access Salesforce Demo Loan Information.\nPlease contact FTIE system administrators.`);
      }
     },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
        getDemoLoanInfo() {
        // /opportunity/back-end/opty-id/<str:opty_id>
        // opportunity/back-end/demo-loan/demo-loan-id/<str:demo_loan_id>
        let self = this;

        let requestData = {
          demo_loan_id: self.demo_loan_id,
        };
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/opportunity/back-end/demo-loan/demo-loan-id/' + self.demo_loan_id, requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'demo_loan_info', null) !== null) {
              self.sf_demo_loan_info = JSON.parse(result.demo_loan_info);
            }
            if (_.get(result, 'account_info', null) !== null) {
              self.sf_account_info = JSON.parse(result.account_info);
            }
            if (_.get(result, 'opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.opty_info);
            }

          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (self.demo_loan_id !== null) {
              console.log("DEMO MASTER self.sf_demo_loan_info");
              console.log(self.sf_demo_loan_info);
              console.log("DEMO MASTER  self.sf_account_info");
              console.log(self.sf_account_info);
              console.log("DEMO MASTER  self.sf_opty_info");
              console.log(self.sf_opty_info);
            }

          });
      },
        sfdcSearchEnabled() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Search Enabled!!");
          return true
        }
        console.log("Search Disabled!!");
        // this.$message.error(`You do not have permissions to access Salesforce Demo Loan Information.\nPlease contact FTIE system administrators.`);
        return false;

      },
      ifUserCanAccess() {
        let self = this;
        console.log("Demo Master ifUserCanAccess:");
        console.log("self.userSites:");
        console.log(self.userSites);
        if (self.sfdcSearchEnabled()) {
          if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
          ) {
            return true
          }
          if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
            console.log("Can only view US opty for GUSA SA !!");
            if (_.get(self.sf_account_info, 'COUNTRY__C', '') == "United States") {
              return true
            }
            else {
              console.log("Can't review this account page");
              return false
            }
          }
        }
        return false;
      },
        checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        console.log("this.$session.has('user_name')");
        console.log(this.$session.has('user_name'));
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/opty-management/DemoLoanMasterPage.vue